// @flow
import { decorate, observable, action } from 'mobx';
import type { Playbook, PlaybookItem } from 'gwu';
import GWUApi from '../../api';
import playbooksData from '../../data/playbooks/playbooks.json';
import fileToPathMap from '../../data/playbooks/content-files';
import marked from 'marked';

class PlaybookStore {
  playbooks: Object = playbooksData;
  playbook: Playbook | null = null;
  isFetchingPlaybook: boolean = false;
  playbookStaticFileContentMap: Object = {};

  async fetchPlaybookContentByFileName(fileName: string) {
    const existing = this.playbookStaticFileContentMap[fileName];
    if (existing) {
      return existing;
    }

    const filePath = fileToPathMap[fileName];
    if (!filePath) {
      return;
    }

    const content = await GWUApi.getStaticFileContent(filePath);
    this.playbookStaticFileContentMap[fileName] = content;

    return content;
  }

  async populateRichContentHelper(item: any, prop: string) {
    const value = item[prop];
    if (!value) {
      return;
    }

    if (value.endsWith('.md')) {
      const fileContent = await this.fetchPlaybookContentByFileName(value);
      item[prop] = marked(fileContent);
    }
  }

  async populatePlaybookItemRichContent(item: PlaybookItem) {
    await this.populateRichContentHelper(item, 'text');
    await this.populateRichContentHelper(item, 'takeaway');
    await this.populateRichContentHelper(item, 'setting');
    await this.populateRichContentHelper(item, 'setup');
    await this.populateRichContentHelper(item, 'technique');
  }

  async getPlaybookByPathwayKey(pathwayKey: string, userLanguage: string) {
    this.isFetchingPlaybook = true;
    const pb = this.playbooks[userLanguage] ? this.playbooks[userLanguage].find(p => p.pathwayKey === pathwayKey) : null;

    if (pb) {
      await this.populatePlaybookItemRichContent(pb.leadItem);
      for (let i = 0; i < pb.items.length; i++) {
        await this.populatePlaybookItemRichContent(pb.items[i]);
      }
      this.playbook = pb;
      this.isFetchingPlaybook = false;

      return;
    }

    this.isFetchingPlaybook = false;
    this.playbook = null;
  }
}

decorate(PlaybookStore, {
  playbooks: observable,
  playbook: observable,
  playbookItem: observable,
  isFetchingPlaybook: observable,
  isFetchingPlaybookItem: observable,
  getPlaybookItemByPath: action,
  getPlaybookByPathwayKey: action
});

export default new PlaybookStore();



// WEBPACK FOOTER //
// ./src/modules/playbook/PlaybookStore.js